import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';

export const CommunitiesError = () => (
  <div
    role="alert"
    className="flex w-full flex-col items-center gap-4 py-10 text-center text-[#8F94A1]"
  >
    <FontAwesomeIcon icon={faTriangleExclamation} size="2x" />
    <Typography variant="headline" size="small" className="text-[#131313]">
      We couldn&apos;t load your communities
    </Typography>
    <Typography as="p" variant="body" size="medium">
      Something went wrong on our end. Please try again.
    </Typography>
    <Button color="neutral" onClick={() => window.location.reload()}>
      Try again
    </Button>
  </div>
);
